import produce from 'immer';
import { SearchConversationEnriched } from 'lib-search-types';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { Conversation, MetaConversation } from 'lib-shared-legacy-types';

export const convertSearchConversationToMetaConversation = (
  conversation: SearchConversationEnriched,
): MetaConversation => {
  const metaConversation: MetaConversation = {
    callersOnHold: [],
    conversation: produce({} as Conversation, (draft) => {
      Object.assign(draft, {
        assignment: null,
        assignments: null,
        async_integrations: [],
        authors: undefined,
        created_at: conversation.created_at,
        direction: conversation.initial_direction,
        events: null,
        id: conversation.id,
        initial_channel: convertChannelCasing(
          conversation.initial_channel,
          'truncate',
        ) as Conversation['initial_channel'],
        inboundmessagecount: conversation.inbound_message_count,
        live_assesment: null,
        is_closed: conversation.status === 'closed',
        is_abandoned: false,
        last_seen: undefined,
        org_id: conversation.organization_id,
        queue: conversation.queue
          ? {
              id: conversation.queue.id,
              name: conversation.queue.name,
              is_restricted: conversation.queue.is_restricted,
            }
          : null,
        queued_at: conversation.queued_at ?? null,
        ratings: [],
        requested_by: conversation.requested_by?.id ?? null,
        tags: [],
        last_message_created_at: conversation.last_message_created_at ?? null,
        outboundmessagecount: conversation.outbound_message_count,
        pending_expiration_at: null,
        pending_at: null,
        pending_by: null,
        status: conversation.status,
        is_callback_consumed: false,
        numeric_id: conversation.id,
        message_delivery_status: null,
      } satisfies Conversation);

      if (conversation.status === 'closed') {
        draft.closed_at = conversation.closed_at;
      }

      draft.attributes = {
        subject: conversation.subject ?? '',
      };
    }),
    emailAddresses: null,
    extraParties: {},
    integrations: [],
    is_updating: false,
    isAssignedToMe: false,
    lastSeen: null,
    linkedConversations: [],
    messages: [],
    parentConversation: null,
    parentConversationRequester: null,
    previousConversations: null,
    requester: {
      id: conversation.requested_by?.id ?? '',
      name: conversation.requested_by?.name ?? '',
      avatar_url: conversation.requested_by?.avatar_url ?? null,
      phone_number: conversation.requested_by?.phone_number ?? null,
      email: conversation.requested_by?.email ?? null,
      type: 'contact',
      org_id: conversation.organization_id ?? null,
      additional_emails: [],
      additional_phone_numbers: [],
      company_id: null,
      default_outbound_number: null,
      anonymized_at: null,
      given_name: null,
      family_name: null,
      has_scim_enabled: false,
      external_id: null,
    },
    unread: 0,
  };

  return metaConversation;
};
